import { render, staticRenderFns } from "./RegisterBuyPackageComponent.vue?vue&type=template&id=5186e4c2&scoped=true"
import script from "./RegisterBuyPackageComponent.vue?vue&type=script&lang=js"
export * from "./RegisterBuyPackageComponent.vue?vue&type=script&lang=js"
import style0 from "./RegisterBuyPackageComponent.vue?vue&type=style&index=0&id=5186e4c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5186e4c2",
  null
  
)

export default component.exports